module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加考察维度")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "width:100%; height:100%;",
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getListData
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "选择考察类型"
    },
    model: {
      value: (_vm.filters.Type),
      callback: function($$v) {
        _vm.$set(_vm.filters, "Type", $$v)
      },
      expression: "filters.Type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "教练考察维度",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "学员考察维度",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "门店考察维度",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "维度名称"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getListData($event)
      }
    },
    model: {
      value: (_vm.filters.Name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "Name", $$v)
      },
      expression: "filters.Name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "1702px"
    },
    attrs: {
      "data": _vm.List,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "维度名称",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Value",
      "label": "维度值",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Step",
      "label": "维度步长",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Type",
      "label": "维度类型",
      "width": "120",
      "formatter": _vm.formatType,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "State",
      "label": "维度状态",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.State == '1') ? _c('el-tag', {
          attrs: {
            "type": "info",
            "size": "medium"
          }
        }, [_vm._v("停用")]) : _vm._e(), _vm._v(" "), (scope.row.State == '0') ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "medium"
          }
        }, [_vm._v("启用")]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "备注",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "变更状态",
      "width": "150",
      "sortable": "",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.Type != 2) ? _c('el-switch', {
          ref: _vm.List[scope.$index].Id,
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#ff4949",
            "disabled": false
          },
          on: {
            "change": function($event) {
              _vm.Change(scope.row, _vm.List[scope.$index].Id)
            }
          },
          model: {
            value: (_vm.List[scope.$index].State == 1 ? false : true),
            callback: function($$v) {
              _vm.$set(_vm.List[scope.$index], "State==1?false:true", $$v)
            },
            expression: "List[scope.$index].State==1?false:true"
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "40",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.Type != 2) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (scope.row.Type != 2) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-tag', [_vm._v("当前有" + _vm._s(_vm.Count) + "个维度")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "维度名称",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.Name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Name", $$v)
      },
      expression: "editForm.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "维度值",
      "prop": "Value"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.Value),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Value", _vm._n($$v))
      },
      expression: "editForm.Value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "维度步长",
      "prop": "Step"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.Step),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Step", _vm._n($$v))
      },
      expression: "editForm.Step"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "维度类型",
      "prop": "Type"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editForm.Type),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Type", $$v)
      },
      expression: "editForm.Type"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("学员考察维度")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("教练考察维度")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 2
    }
  }, [_vm._v("门店考察维度")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editForm.Remark),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Remark", $$v)
      },
      expression: "editForm.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "100px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "维度名称",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.Name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Name", $$v)
      },
      expression: "addForm.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "维度值",
      "prop": "Value"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.Value),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Value", _vm._n($$v))
      },
      expression: "addForm.Value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "维度步长",
      "prop": "Step"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.Step),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Step", _vm._n($$v))
      },
      expression: "addForm.Step"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "维度类型",
      "prop": "Type"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addForm.Type),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Type", $$v)
      },
      expression: "addForm.Type"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("学员考察维度")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("教练考察维度")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.addForm.Remark),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Remark", $$v)
      },
      expression: "addForm.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1df16b62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/BasicSetting/Dimension.vue
// module id = 1326
// module chunks = 1